import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { Subscription } from "rxjs";
import { first } from "rxjs/operators";
import { MatTableDataSource, MatSort, MatPaginator } from "@angular/material";
import { SelectionModel } from "@angular/cdk/collections";

// import { Announcement } from '../../_models';
import { AlertService, AnnouncementService } from "../../_services";

@Component({ templateUrl: "announcement.list.html" })
export class AnnouncementList implements OnInit, OnDestroy {
  heading = "Announcements";
  subheading = "";
  icon = "fa fa-briefcase icon-gradient bg-happy-itmeo";
  link = "/announcement/add";
  announcements: [];
  dataSource: MatTableDataSource<any[]>;
  search_key = "";
  pageSizeOptions = null;

  displayedColumns = ["s_no", "title", "image", "status", "actions"];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    this.pageSizeOptions = setPageSizeOptionsInput.split(",").map(str => +str);
  }

  constructor(
    private announcementServices: AnnouncementService,
    private alertService: AlertService
  ) {}

  ngOnInit() {
    this.loadAllAnnouncements();
  }

  ngOnDestroy() {}

  clearFilters() {
    this.dataSource.filter = "";
    this.search_key = "";
  }

  private loadAllAnnouncements() {
    this.announcementServices
      .getAll()
      .pipe(first())
      .subscribe((announcements: any) => {
        if (announcements.status == "ok") {
          this.dataSource = new MatTableDataSource(announcements.result_set);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      });
  }

  deleteAnnouncement(id: number) {
    this.alertService.delete().then(data => {
      if (data) {
        this.announcementServices
          .delete(id)
          .pipe(first())
          .subscribe((data: any) => {
            if (data.status == "ok") {
              this.alertService.success(data.message, true);
              this.loadAllAnnouncements();
            } else {
              this.alertService.error(data.message, true);
            }
          });
      }
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
}
